// FAQ数据配置
export interface FaqItem {
  label: string;
  children: string | React.ReactElement;
}

// FAQ问题数据（用于faqJsonLd）
export interface FaqQuestion {
  question: string;
  answer: string;
}

// 获取FAQ数据列表（用于组件显示）
export const getFaqDataList = (t: (key: string) => string): FaqItem[] => [
  {
    label: t(`Can I View IG Stories Anonymously?`),
    children: t(
      `You can't be an anonymous Instagram Stories viewer if logged into your account. Dolphin Radar’s Instagram Story Viewer lets you anonymously view public Instagram Stories, Highlights, Reels, Posts, and profile content without logging in. Just enter the IG username of the account you want to view and watch anonymously and securely. No login required!`
    ),
  },
  {
    label: t(`Can I view Someone's Instagram Stories if They Blocked Me?`),
    children: t(
      `Yes, you can still watch someone's Instagram Stories if their account is public, even if they blocked you. Simply copy their Instagram profile URL and paste it into Dolphin Radar's Instagram Story Viewer to see their Stories anonymously. However, if the account is private, Stories won't be accessible, just like with any other viewer tool.`
    ),
  },
  {
    label: t(`Can I Still View Instagram Stories After 24 Hours?`),
    children: t(
      `Yes! With DolphinRadar's Free Anonymous Story Viewer, you can watch Instagram Stories posted within the past 24 hours—no login required. If you want to track and download Stories from an account over time, consider exploring our subscription plans for unlimited access and advanced features. Stay updated and never miss a Story again!`
    ),
  },
  {
    label: t(`How can I view Stories without logging into Instagram?`),
    children: t(
      `DolphinRadar's Instagram Story Viewer gives you private access to Instagram Stories without logging in. You can watch public Stories and Highlights anonymously while staying off the platform. No Instagram account required—just enter the username and start exploring securely!`
    ),
  },
  {
    label: t(`Is the Instagram Story viewer free?`),
    children: t(`Yes! DolphinRadar's Instagram Story Viewer is entirely free.`),
  },
  {
    label: t(`Is the Instagram Story viewer safe to use?`),
    children: t(
      `DolphinRadar is 100% secure and privacy-focused. We track publicly available Instagram data anonymously, with no personal info required, ensuring your privacy is always protected.`
    ),
  },
  {
    label: t(`Does this work for Threads too?`),
    children: t(
      `No, this viewer is for Instagram only. If you're looking to download media from Threads posts, check out our Threads Downloader — it's fast and 100% free.`
    ),
  },
];

// 获取FAQ问题数据（用于page3FaqJsonLd）
export const getFaqQuestions = (t: (key: string) => string): FaqQuestion[] => {
  const faqData = getFaqDataList(t);
  return faqData.map((item) => ({
    question: item.label,
    answer: item.children as string,
  }));
};
